import { Lang } from "@/types/client/client-types"

export const IS_DEV = process.env.NODE_ENV === "development"

export const LANGS = [Lang.en, Lang.ru] as const
